module.exports = __webpack_public_path__ + "img/ic_close.f0634234.svg";